import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import * as types from "@orgmap/store/types";
@Component({
    name: "MemberListItem",
    computed: {
        ...mapGetters({
            options: types.ORG_OPTION_GET,
        }),
    },
    methods: {
        ...mapActions({
            selectDept: types.HR_TREE_CURRENT,
        }),
    },
})
export default class MemberListItem extends Vue {
    @Prop({ type: Object }) item!: orgmap.TMemberItem;
    @Prop({ type: String }) userlang!: string;
    @Prop({ type: Function }) onSelect!: (item: orgmap.TMemberItem) => void;
    @Prop({ type: Function }) onSelectOne!: (item: orgmap.TMemberItem, isSingle: boolean) => void;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    selected: boolean = false;
    photoUrl: string = "";

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    options!: orgmap.TWishContainerOptions;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    selectDept!: (payload: orgmap.Department) => void;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    get hasContainers() {
        return this.options?.containers?.length > 0;
    }

    @Watch("item.selected")
    onSelectedChanged(newVal: boolean) {
        this.selected = newVal;
    }

    @Watch("item")
    onItemChanged(newVal: orgmap.TMemberItem) {
        this.selected = this.item.selected;
        this.photoUrl = this.item.photo ? this.item.photo : "";
    }

    onPhotoError(event: Event) {
        this.photoUrl = "/cm/gres/faux/images/ghost.png";
    }

    onMemberDblClick(e: Event) {
        if (this.hasContainers) {
            this.onSelectOne(this.item, this.options.single || false);
        } else {
            this.onMemberClick(e);
            if (!this.item.personId) {
                this.selectDept({
                    id: this.item.id,
                    deptName: this.item.deptName,
                    deptNameEn: this.item.deptNameEn!,
                    deptNameCh: this.item.deptNameCh,
                    deptNameJp: this.item.deptNameJp,
                    parentDeptCode: this.item.parentDeptCode,
                    email: this.item.email,
                    path: "",
                    hasChildren: this.item.children ? true : false,
                    comCode: this.item.comCode!,
                    selected: true,
                });
            }
        }
    }

    onMemberClick(e: Event) {
        this.onSelect(this.item);
    }

    created() {
        this.onItemChanged(this.item);
    }
}
